export const KEY_BITS = 2048;
export const SEPERATOR = "3241klfhaue";
export const ARR_SEPERATOR = "xmru382mu8m3p9421";
